import { v4 as uuidv4 } from "uuid";
import { timeStamp } from "../../../utils/clock";
import isArray from "lodash/isArray";
export { roundTo } from "../../../utils/tillHelpers";

/**
 * parseDateTime — converts "YYYY-MM-DD HH:mm:ss" into a Date object.
 */
export function parseDateTime(dateTimeString) {
  return new Date(dateTimeString.replace(" ", "T") + "Z");
}

/**
 * calculateDuration — returns { hours, minutes, seconds } between two Date objects.
 */
export function calculateDuration(startTime, endTime) {
  const durationMilliseconds = endTime - startTime;
  const totalSeconds = Math.floor(durationMilliseconds / 1000);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { hours, minutes, seconds };
}

/**
 * formatDuration — formats a duration object as "YYYY-MM-DD HH:mm:ss" using today's date.
 */
export function formatDuration(duration) {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(duration.hours).padStart(2, "0");
  const minutes = String(duration.minutes).padStart(2, "0");
  const seconds = String(duration.seconds).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * formatDate — formats a Date as "YYYY-MM-DD HH:mm:ss".
 */
export const formatDate = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

/**
 * posLogActivity — writes a POS activity log entry.
 *
 * @param {Object}   record    – cart item(s) or string
 * @param {string}   activity  – activity code (e.g. "DLN", "DOR", "RQT", "SLR", "SRD", "ACT")
 * @param {Object}   deps      – { db, cart }
 */
export const posLogActivity = (record, activity, { db, cart }) => {
  const timeMark = timeStamp();
  const currentDate = new Date().toLocaleDateString("zh-Hans-CN");
  let products = "";
  let formattedDuration = "";

  // Calculate duration if orderTimeDetails are present
  if (record.orderTimeDetails) {
    const { orderStartTime, orderEndTime } = record.orderTimeDetails;
    const startTime = parseDateTime(orderStartTime);
    const endTime = parseDateTime(orderEndTime);
    const duration = calculateDuration(startTime, endTime);
    formattedDuration = formatDuration(duration);
  }
  const trxId = uuidv4().replace(/-/g, "").toUpperCase();

  if (isArray(record)) {
    record.forEach((item) => {
      products += `SKU: ${item.value}, Qty: ${item.weight}, Unit Price: ${item.salePrice}, `;
    });
  } else {
    products = `SKU: ${record.value}, Qty: ${record.weight}, Unit Price: ${record.salePrice}, `;
  }

  db.logInformation.add({
    type: activity,
    action: "LOG",
    description: activity === "DLN" || activity === "DOR" || activity === "RQT" || activity === "SLR" ? products : activity === "SRD" || activity === "ACT" ? record : "",
    date: currentDate,
    time: timeMark,
    orderNo: `${cart.documentno}`,
    remarks: "",
    transactionId: `${trxId}`,
    status: "SCS",
    duration: formattedDuration ? `"${formattedDuration}"` : null,
  });
};
